
import { Cmd_batch, Cmd_none, Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { ofNullable } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { ensureValidToken } from "../../Auth.js";
import { ensureRequestBodySize, handleFetchError } from "../../ErrorHandling.js";
import { keyValueList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Types_RequestProperties, Types_HttpRequestHeaders } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { append as append_1, choose, fold, filter, map, singleton as singleton_1, empty as empty_1, exists, isEmpty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { fetch$ } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { concat, printf, toText } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { State, Msg } from "./Types.js";
import { Permissions_allowsInStorage, Permission, Permissions_has } from "../../Shared/Roles.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { Cmd_updateImages, Cmd_downloadFileCmd, Cmd_deleteQrCodes, Cmd_getConsumableDetailDto, Cmd_getConsumableHistoryDto } from "../../Requests/Consumable.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { FormState__startLoading, FormState__setValidationResponse_5219762A, BusinessUnitId, StorageId__get_unwrap, PostResponse$1_$reflection, DocumentDetail_$reflection, FormState_get_empty, RequestedValue$1, ConsumableId } from "../../Shared/Shared.js";
import { Cmd_OfPromise_either as Cmd_OfPromise_either_1 } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { UserConfiguration as UserConfiguration_2, QuickOverviewConfiguration as QuickOverviewConfiguration_1, UserConfiguration_$reflection } from "../../Shared/User.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../Communication.js";
import { Storage_$reflection } from "../../Shared/Storage.js";
import { tuple_type, int32_type, option_type, string_type, class_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { unwrapConsumableId } from "../../Shared/Helper.js";
import { getConsumableNotifications } from "../../Requests/Notification.js";
import { getCustomerConfiguration } from "../../Requests/Configuration.js";
import { getAccountSettings } from "../../Requests/Customer.js";
import { AssignQRCode_$reflection, AssignQRCodeResult_$reflection, AssignQRCode } from "../../Shared/Tool.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { UnassignConsumableQRCode } from "../../Shared/Consumable.js";
import { DnDFormImage } from "../../Widgets/Image/ImageUploadDnD.js";
import { DTO_ManualHookDto_$reflection } from "../../Shared/Procedure.js";
import { BusinessUnitId__get_unwrap } from "../../Shared/Shared.js";
import { getChangelogs } from "../../Requests/Changelog.js";
import { int32ToString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { UpdateImagesDto } from "../../Shared/Image.js";

export function downloadFileCmd(consumableId, documentId, fileName, success, error) {
    return Cmd_OfPromise_either((tupledArg) => {
        const body_1 = tupledArg[2];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let pr;
            const tenant = ofNullable(localStorage.getItem("tenant"));
            return ((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))).then((_arg) => {
                const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                    let matchValue;
                    return append((matchValue = _arg, (matchValue == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                        const matchValue_1 = tenant;
                        if (matchValue_1 == null) {
                            return empty();
                        }
                        else {
                            return singleton(["X-ONE-Tenant", matchValue_1]);
                        }
                    }))));
                })), 0)]);
                const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), headers]);
                return fetch$(addPrefix(tupledArg[0]), props).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg[1]])));
            });
        }));
    }, [toText(printf("/api/consumables/%s/files/%s"))(consumableId.fields[0])(documentId.fields[0]), fileName, undefined], success, error);
}

export function extractBlob(response, filename) {
    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response.blob().then((_arg) => (Promise.resolve([_arg, filename]))))));
}

export function getBlob(response, filename) {
    return Cmd_OfPromise_either((tupledArg) => extractBlob(tupledArg[0], tupledArg[1]), [response, filename], (tupledArg_1) => (new Msg(18, [tupledArg_1[0], tupledArg_1[1]])), (Item_2) => (new Msg(33, [Item_2])));
}

function historyCmd(state) {
    let matchValue_3;
    const matchValue = state.Consumables;
    const matchValue_1 = state.Storages;
    let matchResult, consumable, storages;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
            consumable = matchValue.fields[0];
            storages = matchValue_1.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            if ((matchValue_3 = consumable.StockPerStorage, isEmpty(matchValue_3) ? Permissions_has(state.Permissions, new Permission(32, [])) : exists((sps) => {
                const storageId = sps.StorageId;
                return exists((storage) => {
                    if (unwrapStorageId(storage.Id) === storageId) {
                        return Permissions_allowsInStorage(state.Permissions, new Permission(32, []), state.UserData.UserId, storageId, storage.AssignedUserIds);
                    }
                    else {
                        return false;
                    }
                }, storages);
            }, matchValue_3))) {
                return Cmd_getConsumableHistoryDto((Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(33, [Item_1])), new ConsumableId(parse(consumable.Id)));
            }
            else {
                return singleton_1((dispatch) => {
                    dispatch(new Msg(6, [empty_1()]));
                });
            }
        default:
            return Cmd_none();
    }
}

export function initViewConsumable(consumableId, userData, permissions) {
    return [new State(new RequestedValue$1(0, []), userData, new RequestedValue$1(0, []), new RequestedValue$1(0, []), userData.Customer, {
        FormState: FormState_get_empty(),
        IsOpen: false,
    }, new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), empty_1(), FormState_get_empty(), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), permissions), Cmd_batch(ofArray([Cmd_getConsumableDetailDto((Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(33, [Item_1])), new ConsumableId(consumableId)), Cmd_OfPromise_either_1((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), UserConfiguration_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/users/configuration", (Item_2) => (new Msg(24, [Item_2])), (Item_3) => (new Msg(33, [Item_3]))), Cmd_OfPromise_either_1((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_3), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
        const pr_1 = response_2.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item_4) => (new Msg(25, [Item_4])), (Item_5) => (new Msg(33, [Item_5]))), Cmd_OfPromise_either_1((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_8;
        return ((url_8 = addPrefix(url_6), (refreshOn_1) => fetchWithDecoder(url_8, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_3) => {
            const pr_2 = response_3.arrayBuffer();
            return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(DocumentDetail_$reflection())));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_4 = _arg_1;
            return (result_4.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_4.fields[0]);
            })())) : (Promise.resolve(result_4.fields[0]));
        });
    })), concat("/api/consumables/", unwrapConsumableId(new ConsumableId(consumableId)), ..."/documents"), (Item_6) => (new Msg(19, [Item_6])), (Item_7) => (new Msg(33, [Item_7]))), getConsumableNotifications(new ConsumableId(consumableId), (Item_8) => (new Msg(27, [Item_8])), (Item_9) => (new Msg(33, [Item_9]))), getCustomerConfiguration((Item_10) => (new Msg(28, [Item_10])), (Item_11) => (new Msg(33, [Item_11]))), getAccountSettings((Item_12) => (new Msg(32, [Item_12])), (Item_13) => (new Msg(33, [Item_13])))]))];
}

export function update(msg, state) {
    let IsOpen, copyOfStruct_1, ImagesFormState_5, copyOfStruct, userConfiguration_1, bind$0040_1;
    switch (msg.tag) {
        case 2:
            return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, (IsOpen = !state.QuickOverviewDialog.IsOpen, {
                FormState: FormState_get_empty(),
                IsOpen: IsOpen,
            }), state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
        case 3: {
            const matchValue_1 = state.Consumables;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, Cmd_getConsumableDetailDto((Item_2) => (new Msg(5, [Item_2])), (Item_3) => (new Msg(33, [Item_3])), new ConsumableId(parse(matchValue_1.fields[0].Id)))];
            }
        }
        case 12: {
            const matchValue_2 = state.Consumables;
            if (matchValue_2.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dto = new AssignQRCode(matchValue_2.fields[0].Id, msg.fields[0], unwrapStorageId(msg.fields[1]));
                return [state, Cmd_OfPromise_either_1((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_5;
                    return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_2) => {
                        const pr_1 = response_2.arrayBuffer();
                        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), PostResponse$1_$reflection(AssignQRCodeResult_$reflection())));
                    }, refreshOn_1)))(true);
                })), ["/api/consumables/assignqrcode", toString(0, Auto_generateBoxedEncoder_437914C6(AssignQRCode_$reflection(), undefined, undefined, undefined)(dto))], (Item_5) => (new Msg(13, [Item_5])), (Item_6) => (new Msg(33, [Item_6])))];
            }
        }
        case 13: {
            const response_4 = msg.fields[0];
            return [state, (response_4.tag === 1) ? Cmd_errorToast("validation.toast") : ((response_4.fields[0].Result.tag === 1) ? Cmd_errorToast("assign_qr_code_dialog.qr_code_not_valid") : ((response_4.fields[0].Result.tag === 2) ? Cmd_batch(ofArray([Cmd_successToast("tool.dialog_assign_qr_code"), singleton_1((dispatch) => {
                dispatch(new Msg(3, []));
            })])) : Cmd_errorToast("assign_qr_code_dialog.qr_code_assigned_to_another_tool")))];
        }
        case 14: {
            const matchValue_3 = state.Consumables;
            if (matchValue_3.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, Cmd_deleteQrCodes((Item_7) => (new Msg(15, [Item_7])), (Item_8) => (new Msg(33, [Item_8])), matchValue_3.fields[0].Id, singleton_1(new UnassignConsumableQRCode(singleton_1(msg.fields[0]), StorageId__get_unwrap(msg.fields[1]))))];
            }
        }
        case 15: {
            const matchValue_4 = state.Consumables;
            if (matchValue_4.tag === 0) {
                return [state, Cmd_none()];
            }
            else if (msg.fields[0].tag === 1) {
                return [state, Cmd_errorToast("validation.toast")];
            }
            else {
                return [state, Cmd_batch(ofArray([Cmd_getConsumableDetailDto((Item_9) => (new Msg(5, [Item_9])), (Item_10) => (new Msg(33, [Item_10])), new ConsumableId(parse(matchValue_4.fields[0].Id))), Cmd_successToast("tool.dialog_tool_qr_delete_success")]))];
            }
        }
        case 1: {
            const response_6 = msg.fields[0];
            if (response_6.tag === 1) {
                return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, new RequestedValue$1(1, [empty_1()]), state.Permissions), Cmd_none()];
            }
            else {
                return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, new RequestedValue$1(1, [response_6.fields[0]]), state.Permissions), Cmd_none()];
            }
        }
        case 5: {
            const response_7 = msg.fields[0];
            const labelIds = map((c) => parse(c.CategoryId), response_7.Categories);
            return [new State(new RequestedValue$1(1, [response_7]), state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, map((image) => (new DnDFormImage(1, [{
                ImageUrl: image.ImageUrl,
                Position: image.Position,
            }])), response_7.ConsumableImages), state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_batch(toList(delay(() => append(singleton(singleton_1((dispatch_1) => {
                dispatch_1(new Msg(4, []));
            })), delay(() => append(singleton(singleton_1((dispatch_2) => {
                dispatch_2(new Msg(26, []));
            })), delay(() => append(singleton(Cmd_OfPromise_either_1((tupledArg_2) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_8;
                return ((url_8 = addPrefix(tupledArg_2[0]), (refreshOn_2) => fetchWithDecoder(url_8, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg_2[1]])]), "application/json", (response_8) => {
                    const pr_2 = response_8.arrayBuffer();
                    return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(DTO_ManualHookDto_$reflection())));
                }, refreshOn_2)))(true);
            })), ["/api/procedure-templates/hooks/manual", toString(0, Auto_generateBoxedEncoder_437914C6(list_type(class_type("System.Guid")), undefined, undefined, undefined)(labelIds))], (Item_11) => (new Msg(1, [Item_11])), (Item_12) => (new Msg(33, [Item_12])))), delay(() => {
                const matchValue_5 = response_7.BusinessUnitId;
                return (matchValue_5 == null) ? singleton(singleton_1((dispatch_3) => {
                    dispatch_3(new Msg(29, [undefined]));
                })) : singleton(Cmd_OfPromise_either_1((url_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_11;
                    return ((url_11 = addPrefix(url_9), (refreshOn_3) => fetchWithDecoder(url_11, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_10) => {
                        const pr_3 = response_10.arrayBuffer();
                        return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), option_type(string_type)));
                    }, refreshOn_3)))(true).then((_arg) => {
                        const result_4 = _arg;
                        return (result_4.tag === 1) ? (Promise.resolve((() => {
                            throw new ValidationOnGetRequest(result_4.fields[0]);
                        })())) : (Promise.resolve(result_4.fields[0]));
                    });
                })), concat("/api/business-units/", BusinessUnitId__get_unwrap(new BusinessUnitId(parse(matchValue_5))), ..."/image"), (Item_13) => (new Msg(29, [Item_13])), (Item_14) => (new Msg(33, [Item_14]))));
            })))))))))];
        }
        case 16:
            return [state, downloadFileCmd(msg.fields[0], msg.fields[1], msg.fields[2], (tupledArg_3) => (new Msg(17, [tupledArg_3[0], tupledArg_3[1]])), (Item_18) => (new Msg(33, [Item_18])))];
        case 17:
            return [state, getBlob(msg.fields[0], msg.fields[1])];
        case 18: {
            const url_12 = window.URL.createObjectURL(msg.fields[0]);
            const element = document.createElement("a");
            element.setAttribute("href", url_12);
            element.setAttribute("download", msg.fields[1]);
            document.body.appendChild(element);
            element.click();
            window.URL.revokeObjectURL(url_12);
            element.remove();
            return [state, Cmd_none()];
        }
        case 23: {
            const response_13 = msg.fields[0];
            if (response_13.tag === 1) {
                return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, {
                    FormState: (copyOfStruct_1 = state.QuickOverviewDialog.FormState, FormState__setValidationResponse_5219762A(copyOfStruct_1, response_13.fields[0])),
                    IsOpen: state.QuickOverviewDialog.IsOpen,
                }, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
            }
            else {
                return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, {
                    FormState: FormState_get_empty(),
                    IsOpen: false,
                }, new RequestedValue$1(1, [response_13.fields[0]]), state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_successToast("general.saved_successfully")];
            }
        }
        case 24:
            return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, new RequestedValue$1(1, [msg.fields[0]]), state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
        case 20: {
            const matchValue_6 = state.Consumables;
            if (matchValue_6.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, Cmd_OfPromise_either_1((url_13) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_15;
                    return ((url_15 = addPrefix(url_13), (refreshOn_4) => fetchWithDecoder(url_15, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_14) => {
                        const pr_4 = response_14.arrayBuffer();
                        return pr_4.then((blob_5) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_5)), list_type(DocumentDetail_$reflection())));
                    }, refreshOn_4)))(true).then((_arg_1) => {
                        const result_6 = _arg_1;
                        return (result_6.tag === 1) ? (Promise.resolve((() => {
                            throw new ValidationOnGetRequest(result_6.fields[0]);
                        })())) : (Promise.resolve(result_6.fields[0]));
                    });
                })), concat("/api/consumables/", unwrapConsumableId(new ConsumableId(parse(matchValue_6.fields[0].Id))), ..."/documents"), (Item_20) => (new Msg(19, [Item_20])), (Item_21) => (new Msg(33, [Item_21])))];
            }
        }
        case 19:
            return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, new RequestedValue$1(1, [msg.fields[0]]), state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
        case 4:
            return [state, historyCmd(state)];
        case 6:
            return [new State(state.Consumables, state.UserData, state.Storages, new RequestedValue$1(1, [msg.fields[0]]), state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
        case 21: {
            const matchValue_7 = state.Consumables;
            if (matchValue_7.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, Cmd_batch(ofArray([Cmd_successToast("general.download_started"), Cmd_downloadFileCmd(new ConsumableId(parse(matchValue_7.fields[0].Id)), msg.fields[0], msg.fields[1], (tupledArg_4) => (new Msg(22, [tupledArg_4[0], tupledArg_4[1]])), (Item_25) => (new Msg(33, [Item_25])))]))];
            }
        }
        case 22:
            return [state, getBlob(msg.fields[0], msg.fields[1])];
        case 25:
            return [new State(state.Consumables, state.UserData, new RequestedValue$1(1, [msg.fields[0]]), state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), singleton_1((dispatch_4) => {
                dispatch_4(new Msg(4, []));
            })];
        case 26: {
            const matchValue_8 = state.Consumables;
            if (matchValue_8.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, getConsumableNotifications(new ConsumableId(parse(matchValue_8.fields[0].Id)), (Item_27) => (new Msg(27, [Item_27])), (Item_28) => (new Msg(33, [Item_28])))];
            }
        }
        case 27:
            return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, new RequestedValue$1(1, [msg.fields[0]]), state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
        case 30: {
            const matchValue_9 = state.Consumables;
            if (matchValue_9.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, getChangelogs(matchValue_9.fields[0].Id, (Item_29) => (new Msg(31, [Item_29])), (Item_30) => (new Msg(33, [Item_30])))];
            }
        }
        case 31:
            return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, new RequestedValue$1(1, [msg.fields[0]]), state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
        case 7:
            return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, msg.fields[0], state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
        case 8:
            if (state.Consumables.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const newImages = filter((image_1) => {
                    if (image_1.tag === 1) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }, state.ConsumableImages);
                if (!isEmpty(newImages)) {
                    const formData_1 = fold((formData, image_2) => {
                        if (image_2.tag === 1) {
                        }
                        else {
                            const image_3 = image_2.fields[0];
                            formData.append(int32ToString(image_3.Position), image_3.File, image_3.File.name);
                        }
                        return formData;
                    }, new FormData(), newImages);
                    return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, FormState__startLoading(state.ImagesFormState), state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_OfPromise_either_1((tupledArg_5) => {
                        const formData_3 = tupledArg_5[1];
                        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                            let url_18;
                            ensureRequestBodySize(formData_3);
                            return ((url_18 = addPrefix(tupledArg_5[0]), (refreshOn_5) => fetchWithDecoder(url_18, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_3])]), undefined, (response_22) => {
                                const pr_5 = response_22.arrayBuffer();
                                return pr_5.then((blob_6) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_6)), list_type(tuple_type(int32_type, string_type))));
                            }, refreshOn_5)))(true);
                        }));
                    }, ["/api/files", formData_1], (Item_31) => (new Msg(9, [Item_31])), (Item_32) => (new Msg(33, [Item_32])))];
                }
                else {
                    const dto_3 = choose((toolImage) => {
                        if (toolImage.tag === 1) {
                            const image_4 = toolImage.fields[0];
                            return new UpdateImagesDto(image_4.ImageUrl, image_4.Position);
                        }
                        else {
                            return undefined;
                        }
                    }, state.ConsumableImages);
                    return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, FormState__startLoading(state.ImagesFormState), state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), singleton_1((dispatch_5) => {
                        dispatch_5(new Msg(10, [dto_3]));
                    })];
                }
            }
        case 9: {
            const response_24 = msg.fields[0];
            if (response_24.tag === 1) {
                return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, FormState_get_empty(), state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_errorToast("validation.toast")];
            }
            else {
                let dto_4;
                const list_8 = choose((toolImage_1) => {
                    if (toolImage_1.tag === 1) {
                        const image_5 = toolImage_1.fields[0];
                        return new UpdateImagesDto(image_5.ImageUrl, image_5.Position);
                    }
                    else {
                        return undefined;
                    }
                }, state.ConsumableImages);
                dto_4 = append_1(map((tupledArg_6) => (new UpdateImagesDto(tupledArg_6[1], tupledArg_6[0])), response_24.fields[0]), list_8);
                return [state, singleton_1((dispatch_6) => {
                    dispatch_6(new Msg(10, [dto_4]));
                })];
            }
        }
        case 10: {
            const matchValue_11 = state.Consumables;
            if (matchValue_11.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, Cmd_updateImages(new ConsumableId(parse(matchValue_11.fields[0].Id)), msg.fields[0], (Item_34) => (new Msg(11, [Item_34])), (Item_35) => (new Msg(33, [Item_35])))];
            }
        }
        case 11:
            if (msg.fields[0].tag === 1) {
                return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, empty_1(), FormState_get_empty(), state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, empty_1(), FormState_get_empty(), state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_batch(ofArray([Cmd_successToast("general.upload_image_success"), singleton_1((dispatch_7) => {
                    dispatch_7(new Msg(3, []));
                })]))];
            }
        case 28:
            return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, new RequestedValue$1(1, [msg.fields[0]]), state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
        case 32:
            return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, new RequestedValue$1(1, [msg.fields[0]]), state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), Cmd_none()];
        case 29:
            return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, state.QuickOverviewDialog, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, new RequestedValue$1(1, [msg.fields[0]]), state.ManualHooks, state.Permissions), Cmd_none()];
        case 33:
            return [(ImagesFormState_5 = FormState_get_empty(), new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, {
                FormState: FormState_get_empty(),
                IsOpen: state.QuickOverviewDialog.IsOpen,
            }, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, ImagesFormState_5, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions)), Cmd_errorToast("general.a_error_occured")];
        default: {
            const matchValue = state.UserConfiguration;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const userConfiguration = matchValue.fields[0];
                return [new State(state.Consumables, state.UserData, state.Storages, state.History, state.Customer, {
                    FormState: (copyOfStruct = state.QuickOverviewDialog.FormState, FormState__startLoading(copyOfStruct)),
                    IsOpen: state.QuickOverviewDialog.IsOpen,
                }, state.UserConfiguration, state.Documents, state.Notifications, state.Changelogs, state.CustomerConfiguration, state.ConsumableImages, state.ImagesFormState, state.AccountSettings, state.BusinessUnitImageUrl, state.ManualHooks, state.Permissions), (userConfiguration_1 = (new UserConfiguration_2(userConfiguration.TableConfiguration, (bind$0040_1 = userConfiguration.QuickOverviewConfiguration, new QuickOverviewConfiguration_1(msg.fields[0], bind$0040_1.ToolWithQuantityViewVisibleFieldKeys, bind$0040_1.ToolViewVisibleFieldKeys)))), Cmd_OfPromise_either_1((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), UserConfiguration_$reflection()));
                    }, refreshOn)))(true);
                })), ["/api/users/configuration", toString(0, Auto_generateBoxedEncoder_437914C6(UserConfiguration_$reflection(), undefined, undefined, undefined)(userConfiguration_1))], (Item) => (new Msg(23, [Item])), (Item_1) => (new Msg(33, [Item_1]))))];
            }
        }
    }
}

